import React from 'react';

import { Dot } from 'components/table/Dot';

import { ChartsGrid } from '../ChartsGrid';
import { Donut, DonutProps, DataItem } from '../Donut/Donut';
import { LENS_COLORS, oldColors } from 'constants/colors';


export function TopDonutSection(props: {
  columns: string[],
  donutProps: DonutProps,
  getRowCells: (row: DataItem, i: number) => React.ReactNode[],
  sectionTitle: string,
}) {

  const isLensUI = Boolean(window.GLOBAL_CONFIG.FLIPPERS.LENS_UI);
  const colors = isLensUI ? LENS_COLORS : oldColors;

  return (
    <ChartsGrid
      title={props.sectionTitle}
      charts={[
        <Donut hideLegend {...props.donutProps} />,
        <table className="w-100">
          <thead>
            <tr style={{borderTop: '1px solid #e9ecef'}}>
              {props.columns.map((col, i) => <th key={i}>{col}</th>)}
            </tr>
          </thead>
          <tbody>
            {props.donutProps.data.length > 0 &&
              props.donutProps.data.map((row, i) => (
                <tr key={i} style={{borderTop: '1px solid #e9ecef'}}>
                  {props.getRowCells(row, i).map((cell, j) => (
                    <td key={j}>
                      {j === 0 && <Dot color={colors[i % 11]} />}
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      ]}
    />
  );
}
